import * as echarts from 'echarts'
import { EChartsOption } from 'echarts'

export default function (el: HTMLElement) {
  const myChart = echarts.init(el)

  const setOption = (option: EChartsOption) => {
    myChart.setOption(option)
  }

  window.addEventListener('resize', () => {
    myChart.resize()
  })

  const resize = () => {
    myChart.resize()
  }

  return {
    myChart,
    setOption,
    resize
  }
}
